import ProjectTemplate from '../../components/common/ProjectTemplate';
import StructureEstimateActionButtonsContainer from '../../components/conveyor-structure/StructureEstimateActionButtonsContainer';
import StructureEstimateFormContainer from '../../components/conveyor-structure/StructureEstimateFormContainer';

const StructureEstimatePage = () => {
    return (
        <ProjectTemplate>
            <StructureEstimateFormContainer />
            <StructureEstimateActionButtonsContainer />
        </ProjectTemplate>
    );
};

export default StructureEstimatePage;